import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const cardStyle = {
    background: "#fff",
    border: "1px solid #eceef3",
    borderRadius: 6,
    padding: 20,
    boxShadow: "0 1px 2px rgba(16, 24, 40, 0.04)",
};

const flexStyle = {
    display: "flex",
    alignItems: "center",
    gap: 12,
};

const gridStyle = {
    display: "grid",
    gap: 12,
};

const Card = React.memo(({ children, style }) => (
    <div style={{ ...cardStyle, ...style }}>{children}</div>
));

const FlightBookingSkeleton = () => (
    <>
        <div className="hw-passenger--list">
            <Card style={{ marginBottom: 10, padding: "14px 20px" }}>
                <div style={flexStyle}>
                    <Skeleton circle width={28} height={28} />
                    <Skeleton width={150} height={18} />
                    <Skeleton width={120} height={18} />
                </div>
            </Card>

            <Card>
                <div style={{ ...flexStyle, marginBottom: 18 }}>
                    <Skeleton width={36} height={36} borderRadius={6} />
                    <Skeleton width={180} height={20} />
                </div>

                <Skeleton height={48} style={{ marginBottom: 14 }} />

                <div
                    style={{
                        ...gridStyle,
                        gridTemplateColumns: "repeat(3, 1fr)",
                        marginBottom: 14,
                    }}
                >
                    {Array.from({ length: 3 }, (_, i) => (
                        <Skeleton key={i} height={44} />
                    ))}
                </div>

                <div
                    style={{
                        ...gridStyle,
                        gridTemplateColumns: "repeat(2, 1fr)",
                    }}
                >
                    {Array.from({ length: 2 }, (_, i) => (
                        <Skeleton key={i} height={44} />
                    ))}
                </div>
            </Card>
        </div>

        <aside className="hw-passenger--fareSummary">
            <Card>
                <Skeleton width={130} height={22} style={{ marginBottom: 16 }} />
                <Skeleton height={16} count={4} style={{ marginBottom: 8 }} />
                <Skeleton width="55%" height={24} style={{ margin: "14px 0" }} />
                <Skeleton height={46} />
            </Card>
        </aside>
    </>
);

export default React.memo(FlightBookingSkeleton);